import React, { FC } from "react";

import style from "./style.scss";

export interface UserTotalsProps {
    readonly returningUsers?: number;
    readonly newUsers: number;
    readonly totalUsers: number;
    readonly totalSessions: number;
    readonly fetching?: boolean;
}

export function formatStats(stats: number, fetching?: boolean): string {

    if (fetching) {
        return "-";
    }

    if (stats === undefined || isNaN(stats) || stats === Infinity) {
        return "-";
    }

    // round number to 2 decimal points
    const trimmedStats = parseFloat(stats.toFixed(2));

    return new Intl.NumberFormat().format(trimmedStats);
}

function formatTotalSessions(sessions: number, fetching?: boolean): JSX.Element {

    if (fetching) {
        return <p>-</p>;
    }
    if (sessions === undefined) {
        return <></>;
    }

    const formattedNumber = new Intl.NumberFormat().format(sessions);
    let helperClass = style.default;

    if (sessions > 999999999999) {
        helperClass = style.trillions;
    } else if (sessions > 999999999) {
        helperClass = style.billions;
    } else if (sessions > 999999) {
        helperClass = style.millions;
    }

    return <p className={helperClass}>{formattedNumber}</p>;
}

/**
 * Displays the totals of returning users, new users, total users, total sessions & sessions/user.
 */
const UserTotalsInner: FC<UserTotalsProps> = ({ returningUsers, newUsers, totalUsers, totalSessions, fetching }: UserTotalsProps) => {

    return (
        <div className={style.totals}>
            <div className={style.left}>
                <dl>
                    <dt>New Users</dt>
                    <dd>{formatStats(newUsers, fetching)}</dd>

                    <dt>Returning Users</dt>
                    <dd>{formatStats(returningUsers, fetching)}</dd>

                    <dt>Total Users</dt>
                    <dd>{formatStats(totalUsers, fetching)}</dd>

                    <dt>Avg Sessions / User</dt>
                    <dd>{formatStats(totalSessions / totalUsers, fetching)}</dd>
                </dl>
            </div>

            <div className={style.right}>
                <h4>TOTAL SESSIONS</h4>

                {formatTotalSessions(totalSessions, fetching)}
            </div>
        </div>
    );
};

export const UserTotals = React.memo(UserTotalsInner);
